import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { AdminUser } from '@/shared/types';
import * as authApi from './api';

interface AuthState {
    user: AdminUser | null;
    isLoading: boolean;
    error: string | null;

    signIn: (email: string, password: string) => Promise<void>;
    signOut: () => Promise<void>;
    clearError: () => void;
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set) => ({
            user: null,
            isLoading: false,
            error: null,

            signIn: async (email, password) => {
                set({ isLoading: true, error: null });
                try {
                    const user = await authApi.signIn(email, password);
                    set({ user, isLoading: false });
                } catch (err) {
                    const message =
                        err instanceof Error ? err.message : 'Sign in failed';
                    set({ user: null, isLoading: false, error: message });
                }
            },

            signOut: async () => {
                try {
                    await authApi.logOut();
                } finally {
                    set({ user: null, error: null, isLoading: false });
                }
            },

            clearError: () => set({ error: null }),
        }),
        {
            name: 'pillguide-auth',
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({ user: state.user }),
        },
    ),
);
